import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  TextField,
  InputAdornment,
  Typography,
  SvgIcon,
  makeStyles
} from '@material-ui/core';
import { Search as SearchIcon, Plus as PlusIcon } from 'react-feather';

const useStyles = makeStyles(theme => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  SearchInput: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 10
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '50%'
    },
    width: '100%'
  },
  dateInputBox: {
    margin: 0,
    padding: 0
  }
}));

const Toolbar = ({
  className,
  vendedores,
  setVendedoresSearch,
  input,
  setInput,
  openModal,
  permissions,
  ...rest
}) => {
  const classes = useStyles();
  
  function onChange(e) {
    setInput(e.target.value);
    if (e.target.value.length > 0) {
      let vendedoresFiltrados = vendedores.filter(p => {
        return (
          p.nome.toLowerCase().match(e.target.value.toLowerCase()) ||
          p.cpf.toLowerCase().match(e.target.value.toLowerCase())
        );
      });
      setVendedoresSearch(vendedoresFiltrados);
    } else {
      setVendedoresSearch(vendedores);
    }
  }

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box className={classes.container}>
        <Box maxWidth={500} className={classes.SearchInput}>
          <TextField
            fullWidth
            value={input}
            onChange={onChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              )
            }}
            placeholder="Buscar vendedor"
            variant="outlined"
          />
        </Box>

        {permissions.adicionar && (
          <Box mt={3}>
            <Button
              onClick={openModal}
              color="primary"
              variant="contained"
              style={{
                color: '#fff',
                height: 50,
                width: '16rem',
                marginRight: '1.3rem'
              }}
            >
              <Typography
                style={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <PlusIcon style={{ paddingRight: 3 }} />
                Adicionar novo Vendedor
              </Typography>
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
